import {
  Colors,
  extendTheme,
  ThemeComponents,
  ThemeConfig,
  withDefaultColorScheme,
  withDefaultSize,
} from '@chakra-ui/react';

const colors: Colors = {
  // Base color: #2C4142. Generated by https://smart-swatch.netlify.app
  easeMobile: {
    50: '#f6fbe1',
    100: '#e7f1bd',
    200: '#d9e797',
    300: '#c9dd6e',
    400: '#bad447',
    500: '#CCDF75',
    600: '#7d9122',
    700: '#596816',
    800: '#353e09',
    900: '#111600',
  },
  lightestGreen: '#cbdec04d',
  lightestGold: '#ffdd6433',
  lightestRed: '#f66c4e4d',
  lightestGrey: '#e5e5e580',
  // primaryBackground: '#eef5f4',
  primaryBackground: '#FFF',
  baseColor: '#353e09',
  toggleBgColor: '#4576721A',
  fadedJade: '#457672',
  lightJade: '#4576724D', // faded Jade with 0.3 opacity
  liteOuter: '#2C4142CC', // outer space with 0.8 opacity
  borderColor: '#e7f1bd',
  lighterGold: '#ffdd644d',
  onShift: '#BDA13D',
  telOnly: '#829197',
  checkInOnly: '#94887D',
  horizontalLine: '#2c41424d',
  outerSpaceA01: 'rgba(44, 65, 66, 0.1);',
  lightBlack: '#00000080',
  black: '#2C4142',
  lightBaseColor: '#CCDF75',
  trueBlack: '#000',
  whiteText: '#FFF',
};

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const styles = {
  global: {
    // styles for the `body`
    body: {
      bg: 'primaryBackground',
      color: 'trueBlack',
      fontSize: 'md',
      fontFamily: 'Inter',
      fontWeight: 'normal',
    },
  },
};

const shadows = {
  outline: '0 0 0 3px #49696b',
};

const fonts = 'Inter';

const components: ThemeComponents = {
  Button: {
    baseStyle: {
      borderRadius: '0.5rem',
      _disabled: {
        bg: '#F2F2F2',
        opacity: 1,
        color: 'telOnly',
      },
      _hover: {
        bg: 'trueBlack',
        color: 'whiteText',
        _disabled: {
          bg: '#F2F2F2',
          opacity: 1,
          color: 'telOnly',
        },
      },
    },
    sizes: {
      sm: {
        minW: 50,
        minH: '3rem',
        fontWeight: 'bold',
      },
    },
    variants: {
      primary: {
        bg: 'lightBaseColor',
        color: 'trueBlack',
        fontWeight: '600',
        _hover: {
          bg: 'trueBlack',
          color: 'whiteText',
          _disabled: {
            bg: '#F2F2F2',
            opacity: 1,
            color: 'telOnly',
          },
        },
      },
      secondary: {
        bg: 'trueBlack',
        color: 'whiteText',
        fontWeight: '600',
        _hover: {
          bg: 'lightBlack',
          color: 'whiteText',
          _disabled: {
            bg: '#F2F2F2',
            opacity: 1,
            color: 'telOnly',
          },
        },
      },
    },
  },
  Link: {
    baseStyle: {
      color: 'easeMobile.600',
      textDecoration: 'underline',
    },
  },
  Table: {
    variants: {
      simple: {
        thead: {
          borderColor: 'easeMobile.100',
        },
        tbody: {
          borderColor: 'easeMobile.100',
        },
        th: {
          borderColor: 'easeMobile.100',
        },
        td: {
          borderColor: 'easeMobile.100',
        },
        tr: {
          borderColor: 'easeMobile.100',
        },
      },
    },
  },
  Card: {
    baseStyle: {
      display: 'flex',
      flexDirection: 'column',
      background: 'white',
      alignItems: 'center',
      gap: 6,
    },
    // Two variants: rounded and smooth
    variants: {
      rounded: {
        padding: 8,
        borderRadius: 'xl',
        boxShadow: 'xl',
      },
      smooth: {
        padding: 6,
        borderRadius: 'base',
        boxShadow: 'md',
      },
    },
    // The default variant value
    defaultProps: {
      variant: 'smooth',
    },
  },
};
export const uiTheme = extendTheme(
  {colors, config, components, shadows, styles, fonts},
  withDefaultColorScheme({colorScheme: 'easeMobile'}),
  withDefaultSize({size: 'sm'}),
);
